export default __webpack_public_path__ + "static/media/time-add-button.40e4177a.png";